if (!customElements.get('native-product-fields')) {
  customElements.define('native-product-fields', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.fpConnected === 'true') {
        this.hidden = false;
        return;
      }
      this.dataset.fpConnected = 'true';
      this.mountIntoProductForm();
      this.hideLegacyFields();
      this.bindRequiredValidation();
      this.legacyObserver = new MutationObserver(() => this.hideLegacyFields());
      this.legacyObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => this.legacyObserver.disconnect(), 30000);
    }

    mountIntoProductForm() {
      const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
      const form = forms.find((candidate) => candidate.getAttribute('id') === 'fp-sticker-product-form') ||
        forms.find((candidate) => candidate.querySelector('button[type="submit"],button[name="add"]') && !(candidate.getAttribute('id') || '').includes('installment'));
      if (!form) { this.hidden = false; return; }
      const stickerAnchor = form.querySelector('.fp-locker-phone-card');
      const buttonArea = form.querySelector('.product-form__buttons');
      const submitButton = form.querySelector('button[type="submit"],button[name="add"]');
      const anchor = stickerAnchor || buttonArea || submitButton;
      if (this.usesVaultFirstCheckout() && buttonArea) {
        buttonArea.prepend(this);
        this.hidden = false;
        return;
      }
      if (this.closest('form') === form) { this.hidden = false; return; }
      if (this.matchesGangUpload() && buttonArea && submitButton) submitButton.before(this);
      else if (anchor) anchor.before(this); else form.append(this);
      this.hidden = false;
    }

    bindRequiredValidation() {
      if (!this.matchesGangUpload()) return;
      const form = this.closest('form');
      if (!form || form.dataset.fpNativeValidation === 'true') return;
      form.dataset.fpNativeValidation = 'true';
      form.addEventListener('submit', (event) => {
        const requiredFields = [...this.querySelectorAll('[required]')];
        const invalid = requiredFields.find((field) => !field.checkValidity());
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid.reportValidity();
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    matchesGangUpload() {
      return ['dtf-gang-sheet-12x22', '22in-glitter-dtf-gang-sheet-upload-advanced-users', '22in-sublimation-gang-sheet-upload-advanced-users'].includes(this.dataset.productHandle);
    }

    usesVaultFirstCheckout() {
      return [
        '18x24-yard-sign-single',
        'custom-printed-banner-13-oz',
        'custom-printed-mesh-banner',
        '33-5-x-80-retractable-banner',
        'x-banner-medium',
        'x-banner-large'
      ].includes(this.dataset.productHandle);
    }

    hideLegacyFields() {
      const nativeNames = [...this.querySelectorAll('[name^="properties["]')].map((field) => field.name);
      if (!nativeNames.length) return;
      document.querySelectorAll('[data-tb-app-fields="true"]').forEach((field) => {
        if (!nativeNames.includes(field.name)) return;
        const wrapper = field.closest('.textbox_fields');
        if (wrapper) wrapper.style.setProperty('display', 'none', 'important');
        else field.style.setProperty('display', 'none', 'important');
      });
    }

    disconnectedCallback() {
      if (this.legacyObserver) this.legacyObserver.disconnect();
    }
  });
}
